// Base de datos de abogados por estado
const allStates = [
  'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut',
  'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa',
  'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan',
  'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire',
  'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio',
  'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota',
  'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia',
  'Wisconsin', 'Wyoming', 'Puerto Rico'
];

const gesopsProfile = {
  id: 1,
  name: "Luisa Pastrana",
  firmName: "GesOps LLC",
  specialty: "Directorio Digital & Servicios Administrativos",
  phone: "+1 (804) 960-8133",
  phoneSecondary: "+1 (732) 347-0522",
  email: "gesopsllc@gmail.com",
  isPremium: true,
  slug: "gesops-llc",
  categoryKeys: ["otros-servicios"],
  states: allStates,
  serviceCategories: [
    {
      name: "Servicios de Directorio y Posicionamiento Digital",
      icon: "🟦",
    },
    {
      name: "Servicios de Back Office Paralegal para Abogados",
      icon: "🟧",
    },
    {
      name: "Servicios de Traducción Certificada",
      icon: "🟩",
    }
  ],
  services: [
    "Creación de perfil profesional",
    "Publicidad desde los canales de GesOps",
    "Enlace directo a WhatsApp",
    "Visibilidad dentro del directorio",
    "Posicionamiento de marca",
    "Preparación administrativa de formularios",
    "Organización y revisión documental",
    "Gestión de contratos y follow-up",
    "Coordinación de cartera y pagos",
    "Soporte operativo del caso",
    "Traducciones certificadas válidas para USCIS/DOJ",
    "Traducción de documentos personales y legales",
    "Traducción empresarial y técnica",
    "Entrega digital",
    "Certificado de traducción profesional"
  ],
  bio: "GesOps es una plataforma digital creada para conectar a personas, empresas y profesionales con servicios verificados y confiables en un solo lugar. Nuestro objetivo es ofrecer visibilidad, posicionamiento y herramientas digitales que permitan a cada compañía mostrar sus servicios de manera clara, profesional y segura.\n\nAdemás, GesOps brinda apoyo administrativo especializado a firmas de abogados de inmigración mediante servicios internos de back office paralegal, orientados a optimizar su operación, mejorar la gestión documental y permitir que los abogados se enfoquen en lo legal.\n\nTambién ofrecemos traducciones certificadas para documentos personales, migratorios y empresariales, válidas para USCIS y otras entidades.\n\n(GesOps no ofrece asesoría legal, ni representa clientes ni brinda servicios legales al público.)",
  socialMedia: {
    facebook: "https://www.facebook.com/profile.php?id=61583471817301",
    instagram: "https://www.instagram.com/gesopsllc?igsh=bmF4bnBjYXd0MGtq",
    tiktok: "https://www.tiktok.com/@gesops",
    linkedin: "https://www.linkedin.com/company/gesops"
  },
  photo: "gesops-photo",
  logo: "gesops-logo"
};

const efrenProfile = {
  id: 30,
  name: "Efrén Marrero Negrón",
  firmName: "Sol y Justicia LLC,",
  specialty: "Servicios Legales",
  phone: "+1 (346) 543-5325",
  email: "efren@solyjusticialw.com",
  website: "https://solyjusticialaw.godaddysites.com/",
  isPremium: true,
  slug: "efren-marrero",
  categoryKeys: ["servicios-legales"],
  states: ["Texas", "California", "Arizona", "Colorado", "Illinois", "New York"],
  services: [
    "Asilo Afirmativo y Defensivo",
    "Removal Proceedings (corte)",
    "Apelaciones",
    "Stay of Removal",
    "Peticiones familiares",
    "Ajuste de Status",
    "Parole in Place (PIP)",
    "Waivers",
    "Visa K-1",
    "Visa EB2"
  ],
  bio: "Efren Marrero Negrón es un abogado bilingüe (español e inglés) originario de Puerto Rico, con más de ocho años de experiencia ejerciendo la abogacía y más de cinco años dedicado específicamente al área de inmigración. A lo largo de su carrera, ha trabajado de manera cercana con comunidades migrantes, representando a clientes en procesos ante USCIS, tribunales de inmigración y otras agencias federales.\n\nCon más de doce años de experiencia en servicio al cliente, Efren se destaca por su enfoque empático y orientado a soluciones. Su filosofía de trabajo se basa en escuchar primero, entender la historia de cada persona y diseñar estrategias legales que protejan sus metas y su futuro en los Estados Unidos.\n\nComo padre y orgulloso profesional latino, Efren comprende lo que está en juego cuando una familia deposita su confianza en él. Su misión es acompañar a cada cliente con claridad, respeto y compromiso, asegurando que se sientan informados y acompañados en cada paso del proceso legal.",
  socialMedia: {
    instagram: "https://www.instagram.com/solyjusticia",
    facebook: "https://web.facebook.com/profile.php?id=61581189727184",
    tiktok: "https://www.tiktok.com/@solyjusticiallc"
  },
  photo: "efren-photo",
  logo: "efren-logo"
};

const jesusProfile = {
  id: 33,
  name: "Jesús X. Ríos-Figueroa",
  firmName: "JRios Law Group",
  specialty: "Servicios Legales",
  phone: "864-735-3679",
  email: "contacto@tuabogadojesus.com",
  website: "https://tuabogadojesus.com/?utm_source=ig&utm_medium=social&utm_content=link_in_bio",
  isPremium: true,
  slug: "jesus-rios-figueroa",
  categoryKeys: ["servicios-legales"],
  states: ["Connecticut", "Massachusetts", "New York", "New Jersey", "Pennsylvania", "Maryland", "Virginia", "North Carolina", "Georgia", "Florida", "Puerto Rico", "Tennessee"],
  services: [
    "Representación en Corte de Inmigración",
    "Asilo Defensivo y Afirmativo",
    "Ajuste de Estatus / Green Card",
    "Visas Humanitarias (U, T, VAWA)",
    "Visa de Prometido/a (K1)",
    "Apelaciones y Mociones de Reapertura",
    "Visas EB-2"
  ],
  bio: "Jesús X. Ríos-Figueroa es un abogado de inmigración licenciado en Puerto Rico y autorizado a ejercer el derecho migratorio en los Estados Unidos. Es fundador de JRios Law Group y cuenta con más de quince años de experiencia liderando organizaciones en los sectores público y privado, tanto en Puerto Rico como en Estados Unidos.\n\nSu formación en Comunicación y Periodismo, una Maestría en Economía con concentración en Relaciones Laborales y un Juris Doctor le permite abordar cada caso con visión estratégica, claridad y sensibilidad humana. Ha dirigido equipos legales numerosos y gestionado procesos migratorios complejos, experiencia que hoy se traduce en una práctica sólida, ética y orientada a resultados, sin perder el trato cercano.\n\nEl licenciado Ríos-Figueroa representa a personas y familias ante la Corte de Inmigración en casos de asilo, apelaciones, mociones de reapertura, peticiones familiares, visas humanitarias y visas de trabajo, incluyendo procesos EB-2 por interés nacional. Su enfoque es estructurado, basado en evidencia y adaptado a cada historia.\n\nEn JRios Law Group, el derecho se ejerce con propósito: la información es poder y la fe es fortaleza. Aquí no solo se trabajan casos legales; se acompaña a las personas en la construcción de un futuro con estabilidad y dignidad en los Estados Unidos.",
  socialMedia: {
    instagram: "https://www.instagram.com/tuabogadojesus?igsh=cjB5ZXE5cDM1Zmkx",
    tiktok: "https://www.tiktok.com/@tuabogadojesus?_r=1&_t=ZS-92G9GlY5ADk"
  },
  photo: "jesus-photo",
  logo: "jesus-logo"
};

const therapyWorksProfile = {
  id: 34,
  name: "Ana Marcela Rodríguez",
  firmName: "Therapy Works Counseling Services, PLLC",
  specialty: "Servicios de Salud Mental",
  phone: "(972) 695-3421",
  email: "hola@therapyworkscounseling.com",
  website: "https://www.therapyworkscounseling.com",
  isPremium: true,
  slug: "therapy-works-counseling",
  categoryKeys: ["salud"],
  states: allStates.filter(s => s !== 'New Mexico'),
  customCoverage: {
    evaluaciones: allStates.filter(s => s !== 'New Mexico'),
    terapia: {
      oficinas: [
        { ciudad: "Dallas", direccion: "4054 McKinney Ave. Suite 300, Dallas TX 75204" },
        { ciudad: "Frisco", direccion: "Avon suites 4645 Avon Ln, suites 120A, Frisco TX 75033" },
        { ciudad: "Bedford", direccion: "1101 suite B Bedford Rd, Bedford TX 76022" },
        { ciudad: "Garland", direccion: "629 w Centerville RD suite 209, Garland TX 75041" }
      ],
      online: "Terapia en línea a todo el mundo"
    }
  },
  services: [
    "Terapia individual",
    "Terapia para Adolescentes",
    "Terapia Infantil",
    "Terapia de Pareja",
    "Terapia Familiar",
    "Evaluaciones Clínicas para Inmigración",
    "Evaluaciones de Abusos de Sustancias",
    "Conferencias y Talleres"
  ],
  immigrationServices: [
    "VAWA",
    "Weiver (Perdón)",
    "Asilo",
    "Cancelación de Remoción",
    "VISA - T",
    "VISA - U",
    "Forma N-648"
  ],
  insurances: [
    "Blue Cross Blue Shield",
    "Cigna Healthcare",
    "Aetna",
    "UnitedHealthcare",
    "Oxford Health Plans",
    "Oscar"
  ],
  bio: "En Therapy Works Counseling somos una empresa de servicios de salud mental dedicada a ofrecer servicios psicológicos profesionales y evaluaciones clínicas para casos de inmigración. Contamos con múltiples oficinas y con un equipo de terapeutas bilingües (español e inglés), altamente capacitadas y licenciadas, comprometidas con brindar una atención ética, empática y culturalmente competente.\n\nNuestro enfoque principal es brindar apoyo terapéutico integral a individuos, familias y comunidades, ofreciendo espacios seguros donde nuestros pacientes puedan expresar sus experiencias y trabajar en su bienestar emocional, con especial atención a la población inmigrante y a sus necesidades específicas.",
  socialMedia: {
    instagram: "https://www.instagram.com/therapyworksana",
    facebook: "https://www.facebook.com/therapyworkscounseling",
    tiktok: "https://www.tiktok.com/@therapyworkscounseling",
    youtube: "https://www.youtube.com/@therapyworkscounseling"
  },
  photo: "therapy-photo",
  logo: "therapy-logo"
};

const karitzaProfile = {
  id: 31,
  name: "Karitza Alonso",
  firmName: "KAR Legal Counsel",
  specialty: "Servicios Legales",
  phone: "+1 (804) 960-8133",
  email: "abogadakaritzaalonso@karlegalcounsellllc.com",
  backOfficeClient: true,
  categoryKeys: ["servicios-legales"],
  note: "Atendido por GesOps LLC - Back Office"
};

// Crear el objeto de datos por estado
export const lawyersData = {};

// Agregar GesOps a todos los estados
allStates.forEach(state => {
  const cityMap = {
    'California': 'Los Angeles',
    'Texas': 'Houston',
    'New York': 'New York',
    'Illinois': 'Chicago',
    'Arizona': 'Phoenix',
    'Florida': 'Miami',
    'Georgia': 'Atlanta',
    'Pennsylvania': 'Philadelphia',
    'Massachusetts': 'Boston',
    'Washington': 'Seattle',
    'Colorado': 'Denver',
    'Michigan': 'Detroit',
    'Ohio': 'Columbus',
    'North Carolina': 'Charlotte',
    'Tennessee': 'Nashville',
    'Nevada': 'Las Vegas',
    'Oregon': 'Portland',
    'Virginia': 'Richmond',
    'Maryland': 'Baltimore',
    'Wisconsin': 'Milwaukee',
    'Minnesota': 'Minneapolis',
    'Missouri': 'Kansas City',
    'Indiana': 'Indianapolis',
    'Louisiana': 'New Orleans',
    'Kentucky': 'Louisville',
    'Oklahoma': 'Oklahoma City',
    'Connecticut': 'Hartford',
    'Utah': 'Salt Lake City',
    'Iowa': 'Des Moines',
    'Arkansas': 'Little Rock',
    'Kansas': 'Wichita',
    'New Mexico': 'Albuquerque',
    'Nebraska': 'Omaha',
    'West Virginia': 'Charleston',
    'Idaho': 'Boise',
    'Hawaii': 'Honolulu',
    'New Hampshire': 'Manchester',
    'Maine': 'Portland',
    'Montana': 'Billings',
    'Rhode Island': 'Providence',
    'Delaware': 'Wilmington',
    'South Dakota': 'Sioux Falls',
    'North Dakota': 'Fargo',
    'Alaska': 'Anchorage',
    'Vermont': 'Burlington',
    'Wyoming': 'Cheyenne',
    'Puerto Rico': 'San Juan',
    'Alabama': 'Birmingham',
    'Mississippi': 'Jackson',
    'South Carolina': 'Charleston',
    'New Jersey': 'Newark'
  };

  lawyersData[state] = [
    {
      ...gesopsProfile,
      city: cityMap[state] || state
    }
  ];
});

// Agregar Efrén a sus estados específicos
efrenProfile.states.forEach(state => {
  const cityMap = {
    'California': 'Los Angeles',
    'Texas': 'Houston',
    'New York': 'New York',
    'Illinois': 'Chicago',
    'Arizona': 'Phoenix',
    'Colorado': 'Denver'
  };
  
  lawyersData[state].push({
    ...efrenProfile,
    city: cityMap[state] || state
  });
});

// Agregar Jesús a sus estados específicos
jesusProfile.states.forEach(state => {
  const cityMap = {
    'Connecticut': 'Hartford',
    'Massachusetts': 'Boston',
    'New York': 'New York',
    'New Jersey': 'Newark',
    'Pennsylvania': 'Philadelphia',
    'Maryland': 'Baltimore',
    'Virginia': 'Richmond',
    'North Carolina': 'Charlotte',
    'Georgia': 'Atlanta',
    'Florida': 'Miami',
    'Puerto Rico': 'San Juan',
    'Tennessee': 'Nashville'
  };
  
  lawyersData[state].push({
    ...jesusProfile,
    city: cityMap[state] || state
  });
});

// Agregar Therapy Works a sus estados específicos
therapyWorksProfile.states.forEach(state => {
  const cityMap = {
    'Texas': 'Dallas',
    'Louisiana': 'New Orleans',
    'Florida': 'Miami',
    'Illinois': 'Chicago',
    'Massachusetts': 'Bedford'
  };
  
  lawyersData[state].push({
    ...therapyWorksProfile,
    city: cityMap[state] || state
  });
});

// Agregar Karitza a Florida y Puerto Rico
lawyersData['Florida'].push({
  ...karitzaProfile,
  city: 'Florida'
});

lawyersData['Puerto Rico'].push({
  ...karitzaProfile,
  id: 32,
  phone: "+1 (732) 347-0522",
  city: 'Puerto Rico'
});
